import styled, { ThemeProvider } from 'styled-components/macro';
import { Provider } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { OnomyEthProvider } from '@onomy/react-eth';

// import Exchange from './components/Exchange/Exchange';
import { Sidebar } from './components/Sidebar/Sidebar';
import { GlobalStyle } from './GlobalStyle';
import { store } from './store/store';
import { light } from './themes';
import Wallet from './components/Wallet/Wallet';
// import Bonding from './components/Bonding/Bonding';
import { breakpoints } from './breakpoints';
import './assets/fonts.css';
import {
  REACT_APP_GRAPHQL_ENDPOINT,
  REACT_APP_WNOM_CONTRACT_ADDRESS,
  REACT_APP_BONDING_NOM_CONTRACT_ADDRESS,
  REACT_APP_GRAVITY_CONTRACT_ADDRESS,
} from './constants/env';
import AuthProvider from './AuthProvider';

const MainLayout = styled.div`
  display: grid;
  grid-template-columns: auto auto;

  height: 100%;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.tablet}) {
    padding: 128px 0 0;
  }

  @media screen and (max-width: ${breakpoints.desktopLarge}) {
    grid-template-columns: auto 1fr;
  }
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1440px;

  @media screen and (max-width: ${breakpoints.desktopLarge}) {
    max-width: none;
  }
`;
function App() {
  return (
    <OnomyEthProvider
      graphQlEndpoint={REACT_APP_GRAPHQL_ENDPOINT}
      nomContractAddress={REACT_APP_WNOM_CONTRACT_ADDRESS}
      bondContractAddress={REACT_APP_BONDING_NOM_CONTRACT_ADDRESS}
      gravityContractAddress={REACT_APP_GRAVITY_CONTRACT_ADDRESS}
    >
      <Provider store={store}>
        <ThemeProvider theme={light}>
          <AuthProvider>
            <GlobalStyle />
            <MainLayout>
              <Sidebar />
              <Content>
                <Routes>
                  <Route path="/" element={<Navigate replace to="/wallet" />} />
                  <Route path="/wallet/*" element={<Wallet />} />
                  {/*<Route path="/exchange" element={<Exchange />} />*/}
                </Routes>
              </Content>
            </MainLayout>
          </AuthProvider>
        </ThemeProvider>
      </Provider>
    </OnomyEthProvider>
  );
}

export default App;
